import React, { Component } from 'react'

import Breadcrumbs from '../block/Breadcrumbs'
import Production from '../block/Production'
import About from '../block/About'
import Faq from '../block/Faq'

class App extends Component {

  render() {

    const data = this.props?.data

    return (
      <>
        <Breadcrumbs breadcrumbs={data?.breadcrumbs || []} />
        <Production data={data} />
        <About data={data} />
        <Faq data={data} />
      </>
    )
  }
}

export default App